@if (consent.visible()) {
  <section class="cookie-notice shadow" role="region" aria-labelledby="cookie-heading">
    <div class="d-flex align-items-start gap-3">
      <span class="cookie-icon" aria-hidden="true"><i class="bi bi-shield-check"></i></span>
      <div class="flex-grow-1 min-w-0">
        <h2 class="h5 mb-2" id="cookie-heading">ระบบนี้มีการใช้งานคุกกี้ (Cookies)</h2>
        <p class="mb-2">สำนักงานการปฏิรูปที่ดินเพื่อเกษตรกรรม (ส.ป.ก.) ใช้คุกกี้ที่จำเป็นสำหรับการทำงานของระบบ ท่านสามารถเลือกยอมรับหรือปฏิเสธคุกกี้ที่ไม่จำเป็น และกำหนดความยินยอมได้ที่ตั้งค่าคุกกี้</p>
        <p class="mb-3">อ่านรายละเอียดเพิ่มเติมได้ที่
          <a href="https://alro.go.th/th/alro/consent/ประกาศความเป็นส่วนตัว-Privacy-Notice" target="_blank" rel="noopener noreferrer">นโยบายความเป็นส่วนตัว</a> /
          <a href="https://alro.go.th/th/alro/consent/นโยบายการใช้คุกกี้" target="_blank" rel="noopener noreferrer">นโยบายคุกกี้</a>
        </p>
        @if (consent.settingsOpen()) {
          <div class="cookie-settings border rounded p-3 mb-3">
            <div class="d-flex justify-content-between gap-3 mb-2">
              <div><strong>คุกกี้ที่จำเป็น</strong><div class="small text-secondary">ใช้สำหรับการเข้าสู่ระบบและการทำงานที่จำเป็น</div></div>
              <span class="small text-secondary">เปิดเสมอ</span>
            </div>
            <div class="form-check form-switch mt-3">
              <input id="cookie-analytics" class="form-check-input" type="checkbox" [checked]="consent.draftAnalytics()" (change)="changeAnalytics($event)" />
              <label class="form-check-label" for="cookie-analytics">คุกกี้วิเคราะห์การใช้งาน</label>
              <div class="small text-secondary">ปัจจุบันระบบยังไม่มีการใช้คุกกี้ประเภทนี้</div>
            </div>
          </div>
          <div class="d-flex flex-wrap gap-2">
            <button type="button" class="btn btn-primary" (click)="consent.save(consent.draftAnalytics())">บันทึกการตั้งค่า</button>
            <button type="button" class="btn btn-outline-primary" (click)="consent.save(false)">ปฏิเสธคุกกี้ที่ไม่จำเป็น</button>
          </div>
        } @else {
          <div class="d-flex flex-wrap gap-2">
            <button type="button" class="btn btn-primary" (click)="consent.save(true)">ยอมรับทั้งหมด</button>
            <button type="button" class="btn btn-outline-primary" (click)="consent.save(false)">ปฏิเสธคุกกี้ที่ไม่จำเป็น</button>
            <button type="button" class="btn btn-outline-primary" (click)="consent.openSettings()">ตั้งค่าคุกกี้</button>
          </div>
        }
      </div>
    </div>
  </section>
}
